import { Map } from 'immutable';
import { createReducerBySpec } from '@Utils/Redux/reducerFactory';

import {
  batchExecutionDetailsModalSetIsLoadingReducerType,
  batchExecutionDetailsModalSetQueriesReducerType,
  batchExecutionDetailsModalSetFilenameReducerType,
  batchExecutionDetailsModalSetContextReducerType,
  batchExecutionDetailsModalSetOptionsReducerType,
  batchExecutionDetailsModalSetDetailsListReducerType,
  batchExecutionDetailsModalSetIsShowPicturesReducerType,
} from './BatchExecutionDetailsModalConstants';

export const initialState = Map({
  isLoading: false,
  queries: null,
  filename: null,
  context: null,
  options: null,
  detailsList: [],
  isShowPictures: false,
});

const spec = {
  [batchExecutionDetailsModalSetIsLoadingReducerType]: (state, action) => {
    const { isLoading } = action.payload;
    return state.set('isLoading', isLoading);
  },
  [batchExecutionDetailsModalSetQueriesReducerType]: (state, action) => {
    const { queries } = action.payload;
    return state.set('queries', queries);
  },
  [batchExecutionDetailsModalSetFilenameReducerType]: (state, action) => {
    const { filename } = action.payload;
    return state.set('filename', filename);
  },
  [batchExecutionDetailsModalSetOptionsReducerType]: (state, action) => {
    const { options } = action.payload;
    return state.set('options', options);
  },
  [batchExecutionDetailsModalSetContextReducerType]: (state, action) => {
    const { context } = action.payload;
    return state.set('context', context);
  },
  [batchExecutionDetailsModalSetDetailsListReducerType]: (state, action) => {
    const { detailsList } = action.payload;
    return state.set('detailsList', detailsList);
  },
  [batchExecutionDetailsModalSetIsShowPicturesReducerType]: (state, action) => {
    const { isShowPictures } = action.payload;
    return state.set('isShowPictures', isShowPictures);
  },
};

export default createReducerBySpec(spec, initialState);
